import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RankChangeBadgeProps {
  change: number;
  className?: string;
}

export const RankChangeBadge: React.FC<RankChangeBadgeProps> = ({ change, className }) => {
  const getChangeConfig = () => {
    if (change > 0) {
      return {
        icon: TrendingUp,
        text: `+${change}`,
        bgColor: 'bg-emerald-400/20',
        textColor: 'text-emerald-400',
        borderColor: 'border-emerald-400/30',
      };
    } else if (change < 0) {
      return {
        icon: TrendingDown,
        text: `${change}`,
        bgColor: 'bg-red-400/20',
        textColor: 'text-red-400',
        borderColor: 'border-red-400/30',
      };
    } else {
      return {
        icon: Minus,
        text: '0',
        bgColor: 'bg-blue-400/20',
        textColor: 'text-blue-400',
        borderColor: 'border-blue-400/30',
      };
    }
  };

  const config = getChangeConfig();
  const Icon = config.icon;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 px-2 py-1 rounded-full border',
        'font-bold text-xs leading-none',
        'backdrop-blur-sm transition-all duration-200',
        config.bgColor,
        config.textColor,
        config.borderColor,
        className
      )}
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={2.5} />
      <span>{config.text}</span>
    </div>
  );
};
